import { useState } from "react";

import pluginService from "api/pluginService";
import { ItemKind } from "dto/IKindItems";
import { ENotificationType, notification } from "utils/notification";

// Otwarcie aktu prawa miejscowego w Wordzie przez wtyczkę.
//
// Akt to zwykły dokument edytora (ItemKind.EditorDocument) z Type = LegalAct —
// po stronie wtyczki ten typ włącza rozbudowaną wstążkę aktu prawnego: metrykę,
// jednostki redakcyjne, strukturę dokumentu i generowanie XML.
//
// Treść aktu NIE jest szyfrowana, więc — w odróżnieniu od pism — nie trzeba
// wcześniej wstawiać klucza obiektu do kontekstu kluczy.

const useOpenLegalAct = () => {
  const { mutate: openEditor } = pluginService.useOpenEditor();
  const { mutateAsync: checkPlugin } = pluginService.useGetVersionMutated();

  const [busy, setBusy] = useState(false);

  const open = async (documentId: string) => {
    setBusy(true);

    try {
      const version = await checkPlugin(undefined);

      if (!version) {
        notification({
          type: ENotificationType.ERROR,
          title: "Brak wtyczki",
          text: "Wtyczka Nota nie odpowiada — bez niej nie otworzysz aktu w edytorze.",
        });
        return;
      }

      openEditor({ Id: documentId, Kind: ItemKind.EditorDocument });
    } catch {
      notification({
        type: ENotificationType.ERROR,
        title: "Brak wtyczki",
        text: "Wtyczka Nota nie odpowiada — bez niej nie otworzysz aktu w edytorze.",
      });
    } finally {
      setBusy(false);
    }
  };

  return { open, busy };
};

export default useOpenLegalAct;
